import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const CheckmarkIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 16 12" {...props}>
      <path
        d="M5.09091 9.49254L1.27273 5.73134L0 6.98507L5.09091 12L16 1.25373L14.7273 0L5.09091 9.49254Z"
        fillOpacity="0.87"
      />
    </SvgIcon>
  );
});
